// extracted by mini-css-extract-plugin
module.exports = {"root":"expandable-arrow_root__FyQVL","expanded":"expandable-arrow_expanded__5UjhC","line":"expandable-arrow_line__SJEpn"};